module.exports = "<footer class=\"footer\">\n    <span class=\"text-muted\">\n      <i class=\"fa fa-copyright\" aria-hidden=\"true\" style=\"color: red;\"></i>&nbsp;<a href=\"http://www.ege.com\" target=\"_\">2017 Ege Consulting Inc.</a>️ \n    </span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/mediate/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main